import { jsx as _jsx } from "react/jsx-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useState } from 'react';
import { createPortal } from 'react-dom';
import { invalidateSignedDocumentQueries } from '../../utils/invalidate_signed_document_queries';
import { isDocumentVoidable } from '../../utils/signed_document_status.helpers';
import { VoidDocumentModal } from '../../void_document_modal';
export const useVoidDocumentAction = ({ participantId, canVoidConsents, isDocGenEconsentEnabled, apiClient, getApiErrorMessage, }) => {
    const queryClient = useQueryClient();
    const [selectedDocument, setSelectedDocument] = useState(null);
    const isVoidActionEnabled = canVoidConsents && isDocGenEconsentEnabled;
    const canVoidDocument = useCallback((document) => isVoidActionEnabled && isDocumentVoidable(document.ec__status), [isVoidActionEnabled]);
    const openVoidDocument = useCallback((document) => {
        if (!canVoidDocument(document)) {
            return;
        }
        setSelectedDocument(document);
    }, [canVoidDocument]);
    const closeVoidDocument = useCallback(() => setSelectedDocument(null), []);
    const handleVoided = useCallback(() => {
        invalidateSignedDocumentQueries(queryClient, { participantId, documentId: selectedDocument?._id });
    }, [participantId, queryClient, selectedDocument]);
    // Portal to document.body so the modal escapes the surrounding TabPanel, matching CreateConsentModal.
    const voidDocumentModal = isVoidActionEnabled
        ? createPortal(_jsx(VoidDocumentModal, { document: selectedDocument, isOpen: !!selectedDocument, onClose: closeVoidDocument, onVoided: handleVoided, apiClient: apiClient, getApiErrorMessage: getApiErrorMessage }), document.body)
        : null;
    return { canVoidDocument, openVoidDocument, voidDocumentModal };
};
